export default __webpack_public_path__ + "static/media/logo-EMF.f1191292.png";